<template>
  <div class="wxgzhTips" v-show="show" @touchmove.prevent @mousewheel.prevent>
    <i class="bg" @click="close()"></i>
    <div class="tipscontent">
      <p class="title f15">{{title}}</p>
      <img class="imgBase" :src="imgurl" alt="">
      <div class="close" >
        回复："<span>{{wxGzhTips}}</span>"或数字"<span>{{info.id}}</span>"
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapMutations} from "vuex"
  import {actioncode} from "@/api/api.js"
  export default {
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')),
        title:"扫码二维码关注公众号",
        imgurl:'',
        show:false
      }
    },
    async created(){
      this.toastLoading('加载中···')
      try {
        let res= await actioncode({
          action_id: this.info.id,
        })
        this.imgurl=res.data.data
        this.toastClose()
      } catch (error) {
        this.toastClose()
      }
      setTimeout(() => {
        this.show=true
      }, 300);
    },
    methods:{
      ...mapMutations('showData',['changeTFalse']),
      close(){
        this.changeTFalse([{name:'wxGzhTipsShow',value:false},{name:'wxGzhTips',value:''}])
      }
    },
    mounted(){

    },
    computed:{
      ...mapState('showData',['wxtipsShow','wxGzhTips'])
    }
  }
</script>

<style lang="less" scoped>
div.wxgzhTips{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  display: flex;
  align-items: center;
  justify-content: center;
  .bg{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: rgba(0, 0, 0,.5);
  }
  .tipscontent{
    position: relative;
    z-index: 2;
    width: 8rem;
    background: white;
    border-radius: .2666667rem;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p.title{
      padding: .5333333rem;
    }
    div.close{
      padding: .1rem 0 .4rem;
      span{
        color: #ee0a24;
      }
      font-size: .3733333rem;
    }
    img{
      width: 100%;
    }
  }
}
</style>